type FormStateComparisonInput<Value> = {
  baseline: Value;
  current: Value;
};

/**
 * CMP form state is made from plain serializable objects and arrays. Compare
 * the full value with its saved baseline so an edit that is fully restored is
 * clean again. Keep transient UI state, errors, and loading flags out of the
 * values passed to this helper.
 */
export const hasUnsavedFormChanges = <Value>({
  baseline,
  current,
}: FormStateComparisonInput<Value>): boolean =>
  JSON.stringify(current) !== JSON.stringify(baseline);
